import React, { useState } from 'react';
import Swal from 'sweetalert2'

import * as apiCompany from "../../../../api/apiCompany"
import { ContentBox } from '../ContentBox';
import { CancelSubmitButton } from '../../Res/BaseButton';
import { RespCompany } from '../../../../item/ItemCompany';
import { SystemPromptInput } from '../../Res/SystemPrompt';
import { SingleInput } from '../../Res/BaseInput';

export function CompanyAdd({setIsLoading}) {
  const [companyName, setCompanyName] = useState("")
  const [texIdNumber, setTexIdNumber] = useState("")
  //const [businessArea, setBusinessArea] = useState("")
  const [note, setNote] = useState("")

  var title = '公司資訊'
  var title_tools = ''
  var content =
    <div class="row">
      <div class="col-md-12">
        <SingleInput title={"名稱"} val={companyName} action={setCompanyName} placeholder={"XX股份有限公司"} size={4} />
        <SingleInput title={"統編 - 無法變更, 務必正確"} val={texIdNumber} action={setTexIdNumber} placeholder={"12345678"} size={4} />
        <SingleInput title={"註記"} val={note} action={setNote} placeholder={"XXXXX"} size={4} />
      </div>
    </div>

  var footer =
    <div className="row">
      <div className="col-sm-3 col-sm-offset-9">
        <CancelSubmitButton cancelAction={toCancel} submitName={"儲存"} submitAction={toAdd} isRight={true} />
      </div>
    </div>

  function toCancel() {
    window.history.back(-1);
  }

  async function toAdd() {
    var mRespCompany = new RespCompany({
      companyName,
      texIdNumber,
      //businessArea,
      note,
      isDisable: 0
    })
    if (companyName === "") {
      Swal.fire({
        type: 'error',
        title: '提醒',
        text: '公司名稱 不得為空',
      })
      return
    }
    if (texIdNumber === "") {
      Swal.fire({
        type: 'error',
        title: '提醒',
        text: '統編 不得為空',
      })
      return
    }
    apiCompany.companyAdd({
      mRespCompany,
      success: (jsonData) => {
        if(jsonData.status){
          Swal.fire({
            type: 'success',
            title: '提醒',
            text: '新增成功',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: '立即啟用',
            cancelButtonText: '返回列表',
          }).then(function(result) {
            if (result.value) {
              setCompanyName("")
              setTexIdNumber("")
              //setBusinessArea("")
              setNote("")
              window.location.replace("/CompanyEdit/"+jsonData.companyId);
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              toCancel()
            }
          })
        }else{
          Swal.fire({
            type: 'error',
            title: '提醒',
            text: '新增失敗',
          })
        }
      },
      failure: (err) => {
        Swal.fire({
          type: 'error',
          title: '提醒',
          text: '新增失敗',
        })
      }
    })
  }

  return (
    <>
      <ContentBox title={title} title_tools={title_tools} content={content} footer={footer} hasDrawer={true} />
      <SystemPromptInput />
    </>
    /*
    <section className="content">
 
      <div className="box box-default">
        <div className="box-header with-border">
          <h3 className="box-title">公司 - 新增</h3>
          <div className="box-tools pull-right">
            <button type="button" className="btn btn-box-tool" data-widget="collapse"><i className="fa fa-minus"></i></button>
          </div>
        </div>
        <div className="box-header">
        </div>
        <div className="box-body padding">
          <div className="row">
            <div className="col-sm-6">
                <div className="row">
                  <div className="col-sm-12">
                      <div className="form-group">
                          <label htmlFor="companyName">公司名稱</label>
                          <input type="text" className="form-control" value={companyName} placeholder="" onChange={e=>setCompanyName(e.target.value)} />
                        </div>
                  </div>
                </div>
            </div>
            <div className="col-sm-6">
                <div className="row">
                  <div className="col-sm-12">
                      <div className="form-group">
                          <label htmlFor="exampleInputEmail1">公司統編</label>
                          <input type="text" className="form-control" value={texIdNumber} placeholder="" onChange={e=>setTexIdNumber(e.target.value)} />
                        </div>
                  </div>
                </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
                <div className="row">
                  <div className="col-sm-12">
                      <div className="form-group">
                          <label htmlFor="exampleInputEmail1">營業區域</label>
                          <input type="text" className="form-control" value={businessArea} placeholder="" onChange={e=>setBusinessArea(e.target.value)} />
                        </div>
                  </div>
                </div>
            </div>
            <div className="col-sm-6">
                <div className="row">
                  <div className="col-sm-12">
                      <div className="form-group">
                          <label htmlFor="exampleInputEmail1">註記</label>
                          <input type="text" className="form-control"  value={note} placeholder="" onChange={e=>setNote(e.target.value)} />
                        </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
        <div className="box-footer">
            <button type="submit" className="btn btn-default" onClick={toCancel}>取消</button>
            <button type="submit" className="btn btn-info pull-right" onClick={toAdd}>確定</button>
          </div>
      </div>

      <div className="box box-default">
        <div className="box-header with-border">
            <h3 className="box-title">注意事項</h3>
            <div className="box-tools pull-right">
                <button type="button" className="btn btn-box-tool" data-widget="collapse"><i className="fa fa-minus"></i></button>
              </div>
          </div>

          <div className="box-body">
              <ol>
                <li>有新進員工，請先新增帳號，再指定員工...</li>
                <ol>
                    <li>Phasellus iaculis neque</li>
                    <li>Purus sodales ultricies</li>
                    <li>Vestibulum laoreet porttitor sem</li>
                    <li>Ac tristique libero volutpat at</li>
                  </ol>
                <li>員工離職時....</li>
                <li>職務調動時.....</li>
                  <ol>
                    <li>Phasellus iaculis neque</li>
                    <li>Purus sodales ultricies</li>
                    <li>Vestibulum laoreet porttitor sem</li>
                    <li>Ac tristique libero volutpat at</li>
                  </ol>
              </ol>
            </div>
        </div>
    </section>
    */
  )
}
